<script>
  import ListHeader from '../../../../app/components/list/Header.vue'
  import FormSaveButton from '../../../../app/components/form/SaveButton.vue'
  import FormCancelButton from '../../../../app/components/form/CancelButton.vue'
  import * as restfulService from '../../../services/restfulService'
  import * as notifyService from '../../../services/notifyService'
  import {clone} from 'lodash'
  import {required} from 'vuelidate/lib/validators'
  import bus from '@utils/bus'

  export default {
    components: {ListHeader, FormSaveButton, FormCancelButton},
    data () {
      return {
        isEdit: false,
        isSubmitted: false,
        isLoadingData: true,
        form: {
          name: '',
          description: '',
          type: '',
          min_size: '',
          max_size: ''
        },
        dependencies: {
          type: [{
            value: 'text',
            label: 'Texto'
          }, {
            value: 'textarea',
            label: 'Área de Texto'
          }, {
            value: 'file',
            label: 'Arquivo'
          }]
        }
      }
    },
    validations: {
      form: {
        name: {required},
        description: {required},
        type: {required},
        min_size: {required},
        max_size: {required}
      }
    },
    mounted () {
      const id = this.$route.params.id || null
      if (id) {
        this.isEdit = true
        restfulService.get('field', null, id)
          .then(response => {
            this.form = response
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            console.log(e)
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
      } else {
        this.isLoadingData = false
        bus.$emit('hide-loader')
      }
    },
    methods: {
      onSend () {
        this.isSubmitted = true
        const data = clone(this.form)
        restfulService.save('field', null, null, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.$router.push({name: 'field.index'})
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">

        <ListHeader title="Campos"/>

        <el-card class="el-card__save_form box-card">
            <div slot="header">
                <span>Dados dos Campos</span>
            </div>
            <el-form ref="form"
                     :model="form"
                     label-width="20%"
                     @submit.native.prevent>
                <el-form-item label="Nome"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.name.$error }">
                    <el-input v-model="form.name"
                              @input="$v.form.name.$touch()"/>
                    <div class="el-form-item__error" v-if="$v.form.name.$error">Esse campo é obrigatório</div>
                </el-form-item>
                <el-form-item label="Descrição">
                    <el-input v-model="form.description"
                              type="textarea"
                              :rows="4"/>
                </el-form-item>
                <el-form-item label="Mostrar a descrição como observações?">
                    <el-checkbox v-model="form.show_helper"></el-checkbox>
                </el-form-item>
                <el-form-item label="Tipo"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.type.$error }">
                    <el-select v-model="form.type"
                               placeholder="Selecione..."
                               class="el-select-full"
                               @input="$v.form.type.$touch()">
                        <el-option
                                v-for="item in dependencies.type"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    <div class="el-form-item__error" v-if="$v.form.type.$error">Esse campo é obrigatório</div>
                </el-form-item>
                <el-form-item label="Tamanho Mínimo"
                              class="is-required">
                    <el-input-number v-model="form.min_size"
                                     :min="0"
                                     :step="1"
                                     :max="1000000000000"/>
                </el-form-item>
                <el-form-item label="Tamanho Máximo"
                              class="is-required">
                    <el-input-number v-model="form.max_size"
                                     :min="0"
                                     :step="1"
                                     :max="1000000000000"/>
                </el-form-item>
                <el-form-item>
                    <form-save-button :event-click="onSend"
                                      :is-disabled="isSubmitted || $v.$invalid"
                                      :is-submitted="isSubmitted">
                    </form-save-button>
                    <form-cancel-button route-name="field.index"/>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>



// WEBPACK FOOTER //
// Form.vue?312148c4